import * as React from 'react';
const SvgNextIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} fill="none" {...props}>
    <path
      fill="#fff"
      d="M6.031 11.933V9.8H1.498C.765 9.8.165 9.133.165 8.4V5.6c0-.8.6-1.4 1.333-1.4H6.03V2.067C6.031.6 7.631-.2 8.698.733l5.533 4.934c.8.666.8 1.933 0 2.666l-5.6 4.934c-1 .933-2.6.133-2.6-1.334Z"
    />
  </svg>
);
export default SvgNextIcon;
